import { FC } from 'react'

import { useGET_studentsQuery } from 'redux/api/studentsApi'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'
import GroupEnrollStudentForm from 'components/organisms/forms/GroupEnrollStudentForm'

import { useTableModel } from 'utils/tableModels/useGroupEnrolledStudentsTableModel'

import { useTranslation } from 'react-i18next'
import { ActionType } from 'types'
import { Grid } from '@mui/material'
import { removeEmpty } from 'utils/helpers'


interface IProps {
    action: ActionType
    id: string
    viewOnly: boolean
    tabText?: string
    tabKey?: string
  }

  
const GroupEnrolledStudents: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const filters = {
    group: id,
  }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.enrolled-students')} />
        </Grid>
        <Grid item xs={6}>
          <GroupEnrollStudentForm action={action} id={id} viewOnly={viewOnly} />
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_studentsQuery}
        tableRowParams={ {group_id: id} }
        filters={removeEmpty(filters)}
        header={null}
      />
    </>
  )
}
export default GroupEnrolledStudents
